import { Typography } from "@mui/material";
import { type FC } from "react";

import { EmptyState } from "@/components/empty-state";

interface ClosingEmptyStateProps {
	readonly message: string;
}

export const ClosingEmptyState: FC<ClosingEmptyStateProps> = ({ message }) => (
	<EmptyState iconFontSize={80}>
		<Typography variant="body2" color="text.secondary">
			{message}
		</Typography>
	</EmptyState>
);
